// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectUnitMeasurementsQueryResult, selectUnitMeasurementsPageLoading, selectUnitMeasurementsShowInitWaitingMessage} from '../_selectors/unit-measurement.selectors';

export class UnitMeasurementsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectUnitMeasurementsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectUnitMeasurementsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectUnitMeasurementsQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
